module.exports = __webpack_public_path__ + "static/media/435_Bedroom2.c0602164.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Bedroom2.jpg
// module id = 554
// module chunks = 0